import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Link, useLocation } from "react-router-dom";
import {
  Box,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse,
  IconButton,
  Typography,
  useTheme,
  useMediaQuery,
  Tooltip,
} from "@mui/material";
import {
  KeyboardArrowDown,
  KeyboardArrowRight,
  Menu as MenuIcon,
} from "@mui/icons-material";

// Icons
import DashboardIcon from "@mui/icons-material/Dashboard";
import PeopleIcon from "@mui/icons-material/People";
import AssignmentIcon from "@mui/icons-material/Assignment";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import ReportIcon from "@mui/icons-material/Report";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import ContactMailIcon from "@mui/icons-material/ContactMail";

import ScheduleIcon from "@mui/icons-material/Schedule";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import AssessmentIcon from "@mui/icons-material/Assessment";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import PlaylistAddCheckIcon from "@mui/icons-material/PlaylistAddCheck";
import LocalLibraryIcon from "@mui/icons-material/LocalLibrary";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";

const SideNavbar = ({ forceCollapsed = false }) => {
  const theme = useTheme();
  const location = useLocation();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isTablet = useMediaQuery(theme.breakpoints.between("md", "lg"));
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const [activeMenu, setActiveMenu] = useState(null);
  const [collapsed, setCollapsed] = useState(false);

  useEffect(() => {
    if (forceCollapsed) {
      setCollapsed(true);
    } else if (isSmallScreen || isMobile) {
      setCollapsed(true);
    } else if (isTablet) {
      setCollapsed(true);
    } else {
      setCollapsed(false);
    }
  }, [forceCollapsed, isSmallScreen, isMobile, isTablet]);

  const handleDrawerToggle = () => {
    if (!isMobile && !forceCollapsed) {
      setCollapsed(!collapsed);
    }
  };

  const handleMenuClick = (index) => {
    if (!collapsed) {
      setActiveMenu(activeMenu === index ? null : index);
    }
  };

  const drawerWidth = collapsed ? 72 : 280;

  const menuItems = [
    {
      id: 1,
      title: "Dashboard",
      icon: <DashboardIcon />,
      subItems: [
        {
          id: 11,
          title: "Overview",
          icon: <AnalyticsIcon />,
          path: "/Cadashboard",
        },
        {
          id: 12,
          title: "Quick Actions",
          icon: <AssignmentIcon />,
          path: "/Caquickactions",
        },
      ],
    },
    {
      id: 2,
      title: "Client Management",
      icon: <PeopleIcon />,
      subItems: [
         {
          id: 24,
          title: "Client Selection",
          icon: <PeopleIcon />,
          path: "/CA/clientSelection",
        },
          {
          id: 27,
          title: "Client Companies",
          icon: <AssignmentIcon />,
          path: "/ca/ClientCompanies",
        },
      
       
      
         {
          id: 26,
          title: "Client Tasks",
          icon: <AssignmentIcon />,
          path: "/CA/clientTasks",
        },
        {
          id: 21,
          title: "Client Directory",
          icon: <ContactMailIcon />,
          path: "/Caclientdirectory",
        },
       
        {
          id: 23,
          title: "Client Resources",
          icon: <LocalLibraryIcon />,
          path: "/Caclientresources",
        },
       
      ],
    },
    {
      id: 28,
      title:"Sub Users",
      icon: <PeopleIcon />,
      subItems:[
         {
          id: 21,
          title: "User Creation",
          icon: <ContactMailIcon />,
          path: "/ca/SubUserCreation",
        },
         {
          id: 22,
          title: "Sub User Management",
          icon: <ContactMailIcon />,
          path: "/ca/SubUserManagement",
        },

      ]
      
    },
    {
      id: 3,
      title: "Task Management",
      icon: <AssignmentIcon />,
      subItems: [
        {
          id: 31,
          title: "Task Calendar",
          icon: <ScheduleIcon />,
          path: "/Cataskcalender",
        },
        {
          id: 32,
          title: "Deadline Alerts",
          icon: <NotificationsActiveIcon />,
          path: "/Cadeadlinealert",
        },
        {
          id: 33,
          title: "Periodic Audits",
          icon: <AssessmentIcon />,
          path: "/Capreodicaudits",
        },
        {
          id: 34,
          title: "Compliance Tracking",
          icon: <PlaylistAddCheckIcon />,
          path: "/ComplianceTracking",
        },
      ],
    },
    {
      id: 4,
      title: "Workflow Management",
      icon: <WorkOutlineIcon />,
      subItems: [
        {
          id: 41,
          title: "Staff Allocation",
          icon: <PersonAddIcon />,
          path: "/Cataskapprovalmanagement",
        },
        {
          id: 42,
          title: "Task Approval Flow",
          icon: <AssignmentTurnedInIcon />,
          path: "/TaskFlow",
        },
        {
          id: 43,
          title: "File Tracking",
          icon: <AttachFileIcon />,
          path: "/Cafiletracking",
        },
      ],
    },
    {
      id: 5,
      title: "File Management",
      icon: <FileCopyIcon />,
      subItems: [
        {
          id: 51,
          title: "Document Upload",
          icon: <CloudUploadIcon />,
          path: "/Cadocumentupload",
        },
        {
          id: 52,
          title: "Review Workflow",
          icon: <AssignmentTurnedInIcon />,
          path: "/careviewworkflow",
        },
        {
          id: 53,
          title: "File Lifecycle",
          icon: <AttachFileIcon />,
          path: "/cafilelifecycle",
        },
      ],
    },
    {
      id: 6,
      title: "Reporting",
      icon: <ReportIcon />,
      subItems: [
        {
          id: 61,
          title: "Performance Dashboards",
          icon: <AnalyticsIcon />,
          path: "/CaReportPerformance",
        },
        {
          id: 62,
          title: "Detailed Reports",
          icon: <AssessmentIcon />,
          path: "/CadetailReview",
        },
      ],
    },
    {
      id: 7,
      title: "Admin Control",
      icon: <AdminPanelSettingsIcon />,
      subItems: [
        {
          id: 71,
          title: "Team Management",
          icon: <PersonAddIcon />,
          path: "/CaAdminTeamManagement",
        },
        {
          id: 72,
          title: "Access Controls",
          icon: <AdminPanelSettingsIcon />,
          path: "/AccessControlPage",
        },
      ],
    },
  ];

 
  useEffect(() => {
  
    setActiveMenu(1); 

 
    if (location.pathname.includes("/CA/client")) {
      setActiveMenu(2); 
    }
  }, [location.pathname]);

  const renderMenuItem = (item) => (
    <Box key={item.id}>
      <ListItemButton
        onClick={() => handleMenuClick(item.id)}
        selected={activeMenu === item.id}
        sx={{
          minHeight: 48,
          px: collapsed ? 1.5 : 2.5,
          margin: "4px 16px",
          borderRadius: "8px",
          transition: "all 0.2s ease-in-out",
          "&:hover": {
            backgroundColor: theme.palette.action.hover,
            transform: "translateX(4px)",
            "& .MuiListItemText-primary": {
              color: theme.palette.primary.main,
              fontWeight: "bold",
            },
            "& .MuiListItemIcon-root": {
              color: theme.palette.primary.main,
            },
          },
          "&.Mui-selected": {
            backgroundColor: theme.palette.action.selected,
            "& .MuiListItemText-primary": {
              color: theme.palette.primary.main,
              fontWeight: "bold",
            },
            "& .MuiListItemIcon-root": {
              color: theme.palette.primary.main,
            },
          },
        }}
      >
        <ListItemIcon
          sx={{
            minWidth: 0,
            mr: collapsed ? 0 : 3,
            justifyContent: "center",
            color: theme.palette.primary.main,
          }}
        >
          <Tooltip
            title={item.title}
            placement="right"
            disableHoverListener={!collapsed}
          >
            {item.icon}
          </Tooltip>
        </ListItemIcon>
        {!collapsed && (
          <>
            <ListItemText
              primary={item.title}
              sx={{
                "& .MuiListItemText-primary": {
                  fontSize: "0.875rem",
                  fontWeight: 500,
                },
              }}
            />
            {activeMenu === item.id ? (
              <KeyboardArrowRight />
            ) : (
              <KeyboardArrowDown />
            )}
          </>
        )}
      </ListItemButton>

      {!collapsed && (
        <Collapse in={activeMenu === item.id} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {item.subItems.map((subItem) => (
              <ListItemButton
                key={subItem.id}
                component={Link}
                to={subItem.path}
                sx={{
                  pl: 4,
                  margin: "2px 16px",
                  borderRadius: "8px",
                  transition: "all 0.2s ease-in-out",
                  "&:hover": {
                    backgroundColor: theme.palette.action.hover,
                    transform: "translateX(4px)",
                    "& .MuiListItemText-primary": {
                      color: theme.palette.primary.main,
                      fontWeight: "bold",
                    },
                  },
                  ...(location.pathname === subItem.path && {
                    backgroundColor: theme.palette.action.selected,
                    "& .MuiListItemText-primary": {
                      color: theme.palette.primary.main,
                      fontWeight: "bold",
                    },
                  }),
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: 2,
                    justifyContent: "center",
                    color: theme.palette.primary.main,
                  }}
                >
                  {React.cloneElement(subItem.icon, {
                    style: { fontSize: 16 },
                  })}
                </ListItemIcon>
                <ListItemText
                  primary={subItem.title}
                  sx={{
                    "& .MuiListItemText-primary": {
                      fontSize: "0.8rem",
                    },
                  }}
                />
              </ListItemButton>
            ))}
          </List>
        </Collapse>
      )}
    </Box>
  );

  const drawer = (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
      {/* Header */}
      <Box
        sx={{
          p: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: collapsed ? "center" : "space-between",
          borderBottom: "1px solid",
          borderColor: "divider",
          minHeight: 64,
          flexShrink: 0,
        }}
      >
        {!collapsed && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
          
            <Typography
              variant="h6"
              component="span"
              sx={{
                color: theme.palette.text.primary,
                fontSize: "1.5rem",
                fontWeight: "bold",
              }}
            >
              CA 
            </Typography>
            <Typography
              variant="h6"
              component="span"
              sx={{
                color: theme.palette.primary.main,
                fontSize: "1.5rem",
                fontWeight: "bold",
                 ml: 1,
              }}
            >
              Portal
            </Typography>
          </Box>
        )}
        {!isMobile && !forceCollapsed && (
          <IconButton onClick={handleDrawerToggle} size="small">
            <MenuIcon />
          </IconButton>
        )}
      </Box>

      {/* Menu Items */}
      <Box
        sx={{
          flexGrow: 1,
          overflow: "auto",
        }}
      >
        <List>{menuItems.map(renderMenuItem)}</List>
      </Box>

      {/* Footer */}
      <Box
        sx={{
          borderTop: "1px solid",
          borderColor: "divider",
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-start",
          minHeight: {
            xs: 120,
            sm: 140,
            md: collapsed ? 100 : 160,
            lg: 180,
          },
          flexShrink: 0,
          backgroundColor: theme.palette.background.default,
        }}
      >
        <Box
          component="img"
          src="/icon.jpg"
          alt="Company Logo"
          sx={{
            height: {
              xs: collapsed ? 40 : 60,
              sm: collapsed ? 50 : 70,
              md: collapsed ? 60 : 90,
              lg: collapsed ? 70 : 120,
            },
            width: "auto",
            objectFit: "contain",
            maxWidth: {
              xs: collapsed ? "33px" : "148px",
              sm: collapsed ? "38px" : "178px",
              md: collapsed ? "43px" : "198px",
              lg: collapsed ? "48px" : "218px",
            },
            display: "block",
            mt: { xs: 0.5, sm: 1 },
          }}
        />
      </Box>
    </Box>
  );

  return (
    <motion.div
      animate={{ width: drawerWidth }}
      transition={{ duration: 0.3, ease: "easeInOut" }}
      style={{
        width: drawerWidth,
        flexShrink: 0,
        height: "100%",
        position: "relative",
      }}
    >
      <Box
        sx={{
          width: drawerWidth,
          height: "100%",
          borderRight: "1px solid",
          borderColor: theme.palette.divider,
          backgroundColor: theme.palette.background.paper,
          overflow: "hidden",
          position: "fixed",
          top: 64,
          left: 0,
          bottom: 0,
          zIndex: 1100,
          display: "flex",
          flexDirection: "column",
          "&::after": {
            content: '""',
            position: "absolute",
            top: 0,
            right: 0,
            bottom: 0,
            width: !collapsed ? "3px" : "0px",
            backgroundColor: theme.palette.primary.main,
            transition: "width 0.3s ease-in-out",
            zIndex: 1,
          },
        }}
      >
        {drawer}
      </Box>
    </motion.div>
  );
};

export default SideNavbar;
